<template functional>
  <div class="cart-list">
    <!--
      @slot intended for one or more CartListLineItem
    -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CartList'
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.cart-list {
  padding-bottom: 10px;
  max-height: 310px;
  overflow-y: auto;
}

/deep/ .cart-list-line-item:not(:last-child) {
  border-bottom: 2px solid $grey;
  padding-bottom: 5px;
}
</style>
